export const CAL_EVENT_FIELD_PHASES = ['creation', 'beforeStart', 'afterStart'];
//# sourceMappingURL=cal-event-field-phases.js.map